<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS</span>
                </h4>
                <app-tabela
                    :itens="contratosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row class="mt-2">
                            <b-col sm="12">
                                <div class="float-right">
                                    <b-form-checkbox
                                        v-model="apenasContratosAtivos"
                                        :value="true"
                                        :unchecked-value="false"
                                        ><strong>
                                            APENAS CONTRATOS ATIVOS</strong
                                        >
                                    </b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="nuValorGlobalContrato" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuValorGlobalContrato | currency
                        }}</span>
                    </template>
                    <template slot="nuSaldoContrato" slot-scope="data">
                        <span class="text-nowrap">{{
                            data.nuSaldoContrato | currency
                        }}</span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{
                            data.dtInicioVigencia
                                ? $moment(data.dtInicioVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{
                            data.dtFimVigencia
                                ? $moment(data.dtFimVigencia).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="noPrazo" slot-scope="data">
                        <app-status
                            :status="data.noPrazo ? 'NO PRAZO' : 'VENCIDO'"
                        ></app-status>
                    </template>
                    <template slot="situacaoContrato" slot-scope="data">
                        <app-status
                            :status="data.situacaoContrato.toUpperCase()"
                        ></app-status>
                    </template>
                    <template slot="nuSaldoContrato" slot-scope="data">{{
                        data.nuSaldoContrato | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary mr-1" v-if="permiteDetalhar">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharContrato(data.idContrato)"
                            ></i>
                        </span>
                    </template>
                    <template slot="vinculoRM" slot-scope="data">
                        <app-status
                            :status="data.vinculoRM ? 'OK' : 'NOK'"
                        ></app-status>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    props: {
        dataServicos: {
            type: Object
        },

        rotaDetalhar: {
            type: String
        },

        rotaListagem: {
            type: String
        },

        permiteDetalhar: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            apenasContratosAtivos: true,
            contratos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'processo',
                    label: 'Processo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjetoContrato',
                    label: 'Objeto',
                    filterable: true,
                    tdClass: 'colObjeto'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nuValorGlobalContrato',
                    label: 'Valor do Contrato'
                },
                {
                    key: 'nuSaldoContrato',
                    label: 'Saldo do Contrato'
                },
                {
                    key: 'vigencia',
                    label: 'Prazo'
                },
                {
                    key: 'situacaoContrato',
                    label: 'Situação',
                    filterable: true
                },
                {
                    key: 'noPrazo',
                    label: 'Status'
                },
                {
                    key: 'vinculoRM',
                    label: 'RM'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterContratos() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterTodos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.error[0]
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharContrato(id) {
            this.$router.push({
                name: this.rotaDetalhar,
                params: {
                    contratoId: id
                }
            })
        }
    },

    created() {
        this.obterContratos()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === this.rotaListagem
        },

        contratosFiltrados() {
            if (this.apenasContratosAtivos) {
                return [
                    ...this.contratos.filter((contrato) => {
                        return contrato.noPrazo == true
                    })
                ]
            }
            return [...this.contratos]
        }
    }
}
</script>
